const styles = {
  wrapper: 'flex flex-col xl:items-stretch',
  navItem: 'mb-12',
};

export default styles;
